const mobileConfig = {
  data() {
    return {
      // 功能组件类型开始
      COM_GOODS_LIST: 10, // 商品列表
      COM_SWIPE: 20, // 幻灯片
      COM_CONTENT: 30, // 图文内容显示
      COM_FORM_INFO: 40, // 表单信息显示
      COM_BTM_MENU: 50, // 底部固定操作菜单
      COM_TOTOP: 60, // 回到顶部悬浮按钮
      // 功能组件类型开始
      // 功能组件列表开始
      componentList: [
        { value: 10, title: '商品列表' },
        { value: 20, title: '幻灯片' },
        { value: 30, title: '图文内容显示' },
        { value: 40, title: '表单信息显示' },
        { value: 50, title: '底部固定操作菜单' },
        { value: 60, title: '回到顶部悬浮按钮' }
      ],
      // 功能组件列表结束
      // 页面布局类型开始
      LAYOUT_FLOW: 10, // 顺序布局
      LAYOUT_FLOW_TAB: 20, // 顺序TAB布局
      // 页面布局类型结束
      // 主题样式开始
      themeList: [
        { theme: 10, title: '酷炫洪睿蓝' }
      ],
      // 主题样式结束
      // 位置开始
      positionList: [
        { value: 10, title: '顺序布局' },
        { value: 20, title: 'TAB布局' },
        { value: 30, title: '头部栏左部' },
        { value: 40, title: '头部栏右部' }
      ]
      // 位置结束
    }
  },
  filters: {
    mPosition(val) {
      if (!val) {
        return ''
      } else {
        switch (val) {
          case 10:
            return '顺序布局'
          case 20:
            return 'TAB布局'
          case 30:
            return '头部栏左部'
          case 40:
            return '头部栏右部'
          default:
            return ''
        }
      }
    },
    /**
     * 功能组件布局类型
     */
    layout(val) {
      if (!val) {
        return ''
      } else {
        switch (val) {
          case 10:
            return '商品列表'
          case 20:
            return '幻灯片'
          case 30:
            return '图文内容显示'
          case 40:
            return '表单信息显示'
          case 50:
            return '底部固定操作菜单'
          case 60:
            return '回到顶部悬浮按钮'
          default:
            return ''
        }
      }
    },
    /**
     * 页面布局类型
     */
    pageType(val) {
      switch (val) {
        case 10:
          return '顺序布局'
        case 20:
          return '顺序-TAB布局'
        default:
          return '顺序-TAB布局'
      }
    }
  }
}
export default mobileConfig



// WEBPACK FOOTER //
// ./src/config/mobileConfig.js